import React, {useRef, useState} from "react"
import productPageImg from "../../../../../assets/website-images/product/bio-page-banner.png"
import productBannerImg from "../../../../../assets/website-images/product/product-banner.jpg";
import {motion, useInView} from "framer-motion";
import PageBanner from "../../../../components/website/pages-banner/PageBanner";
import {Col, Container, Row} from "react-bootstrap";
import box1Img from "../../../../../assets/website-images/product/surveillance/box-1.png";
import box2Img from "../../../../../assets/website-images/product/surveillance/box-2.png";
import box3Img from "../../../../../assets/website-images/product/surveillance/box-3.png";
import box4Img from "../../../../../assets/website-images/product/surveillance/box-4.png";
import box5Img from "../../../../../assets/website-images/product/surveillance/box-5.png";
import box6Img from "../../../../../assets/website-images/product/surveillance/box-6.png";
import "./surveillance.scss"
import bio1 from "../../../../../assets/website-images/product/surveillance/g1.png";
import bio2 from "../../../../../assets/website-images/product/surveillance/g2.png";
import bio3 from "../../../../../assets/website-images/product/surveillance/g3.png";
import bio4 from "../../../../../assets/website-images/product/surveillance/g4.png";
import {useTranslation} from "react-i18next";

export default function UtrustSurveillance() {
    const {t} = useTranslation();
    const ref2 = useRef(null);
    const ref5 = useRef(null);
    const isInView2 = useInView(ref2, { once: true });
    const isInView5 = useInView(ref5, { once: true });
    const ref3 = useRef(null);
    const ref = useRef(null);
    const isInView3 = useInView(ref3, { once: true });
    const isInView = useInView(ref, { once: true }); // Only trigger once
    const [activeSection, setActiveSection] = useState(1);
    const containerVariants2 = {
        hidden: { opacity: 1 },
        show: {
            opacity: 1,
            transition: {
                staggerChildren: 0.3, // Staggering the animation of each child by 0.3 seconds
            },
        },
    };
    const cardVariants = {
        hidden: { opacity: 0, x: -100 }, // Start with opacity 0 and 100px to the left
        show: { opacity: 1, x: 0 },      // Fade in and move to original position
    };


    const handleSectionClick = (sectionIndex) => {
        setActiveSection(sectionIndex);
    };

    return(
        <div className={'bio-page surveilance'}>
            <PageBanner img={productPageImg} heading={t('products.utrust_surveillance.banner_head')} bannerImg={productBannerImg}/>

            <div className={'section-1'}>
                <Container>
                    <Row>
                        <Col md={12}>
                            <p className={''}>
                                {t('products.utrust_surveillance.para_1')}
                            </p>
                            <p className={'mb-4'}>
                                {t('products.utrust_surveillance.para_2')}
                            </p>
                        </Col>
                    </Row>

                    <Row>
                        <Col md={12}>
                            <h2 className={'heading'}>{t('products.utrust_surveillance.section_1.head')}</h2>
                            <h4 className={'sub-heading-3'}>{t('products.utrust_surveillance.section_1.head_sub')}</h4>
                        </Col>
                    </Row>

                    <Row>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box green'}>
                                <img src={box1Img} />
                                <h3>{t('products.utrust_surveillance.section_1.box_1.head')}</h3>
                                <p>{t('products.utrust_surveillance.section_1.box_1.para')}</p>
                                <ul>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_1.head_1')}</span> {t('products.utrust_surveillance.section_1.box_1.para_1')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_1.head_2')}</span> {t('products.utrust_surveillance.section_1.box_1.para_2')} </li>                                </ul>
                            </div>
                        </Col>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box'}>
                                <img src={box2Img} />
                                <h3>{t('products.utrust_surveillance.section_1.box_2.head')}</h3>
                                <p>{t('products.utrust_surveillance.section_1.box_2.para')}</p>
                                <ul>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_2.head_1')}</span> {t('products.utrust_surveillance.section_1.box_2.para_1')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_2.head_2')}</span> {t('products.utrust_surveillance.section_1.box_2.para_2')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_2.head_3')}</span> {t('products.utrust_surveillance.section_1.box_2.para_3')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_2.head_4')}</span> {t('products.utrust_surveillance.section_1.box_2.para_4')} </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row className={'flex-column-reverse flex-lg-row'}>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box'}>
                                <img src={box3Img} />
                                <h3>{t('products.utrust_surveillance.section_1.box_3.head')}</h3>
                                <p>{t('products.utrust_surveillance.section_1.box_3.para')}</p>
                            </div>
                        </Col>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box green'}>
                                <img src={box4Img} />
                                <h3>{t('products.utrust_surveillance.section_1.box_4.head')}</h3>
                                <p>{t('products.utrust_surveillance.section_1.box_4.para')}</p>
                                <ul>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_4.head_1')}</span> {t('products.utrust_surveillance.section_1.box_4.para_1')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_4.head_2')}</span> {t('products.utrust_surveillance.section_1.box_4.para_2')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_4.head_3')}</span> {t('products.utrust_surveillance.section_1.box_4.para_3')} </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box green'}>
                                <img src={box5Img} />
                                <h3>{t('products.utrust_surveillance.section_1.box_5.head')}</h3>
                                <p>{t('products.utrust_surveillance.section_1.box_5.para')}</p>
                                <ul>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_5.head_1')}</span> {t('products.utrust_surveillance.section_1.box_5.para_1')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_5.head_2')}</span> {t('products.utrust_surveillance.section_1.box_5.para_2')} </li>
                                </ul>
                            </div>
                        </Col>
                        <Col lg={6} className={'p-0'}>
                            <div className={'sec-1-box'}>
                                <img src={box6Img} />
                                <h3>{t('products.utrust_surveillance.section_1.box_6.head')}</h3>
                                <p>{t('products.utrust_surveillance.section_1.box_6.para')}</p>
                                <ul>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_6.head_1')}</span> {t('products.utrust_surveillance.section_1.box_6.para_1')} </li>
                                    <li><span>{t('products.utrust_surveillance.section_1.box_6.head_2')}</span> {t('products.utrust_surveillance.section_1.box_6.para_2')} </li>
                                </ul>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className="home-featured-products">
                <Container>
                    <Row>
                        <Col>
                            <div ref={ref2}>
                                <motion.h2
                                    className={'heading'}
                                    initial={{ opacity: 0, y: 100 }}
                                    animate={isInView2 ? { opacity: 1, y: 0 } : { opacity: 0, y: 100 }}
                                    transition={{ duration: 1 }}
                                >
                                    {t('products.utrust_surveillance.section_2.head')}
                                </motion.h2>
                            </div>

                            <div className="cards" ref={ref5}>
                                <Row>
                                    <Col md={6}>
                                        <motion.div
                                            className="product-card"
                                            initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                            animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                            transition={{ duration: 1.4, delay: 1 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio1}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4>{t('products.utrust_surveillance.section_2.box_1.head')}</h4>
                                                        <p>
                                                            {t('products.utrust_surveillance.section_2.box_1.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                    <Col md={6}>
                                        <motion.div
                                            className="product-card"
                                            initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                            animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                            transition={{ duration: 1.4, delay: 2 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio2}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4>{t('products.utrust_surveillance.section_2.box_2.head')}</h4>
                                                        <p>
                                                            {t('products.utrust_surveillance.section_2.box_2.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                    <Col md={6}>
                                        <motion.div
                                            className="product-card"
                                            initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                            animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                            transition={{ duration: 1.4, delay: 3 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio3}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4>{t('products.utrust_surveillance.section_2.box_3.head')}</h4>
                                                        <p>
                                                            {t('products.utrust_surveillance.section_2.box_3.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                    <Col md={6}>
                                        <motion.div style={{display: "flex"}}
                                                    className="product-card"
                                                    initial={{ opacity: 0, y: 50 }} // Start with opacity 0 and move up
                                                    animate={isInView5 ? { opacity: 1, y: 0 } : { opacity: 0, y: 50 }} // Fade in and move to original position
                                                    transition={{ duration: 1.4, delay: 4 * 0.2 }} // Staggered effect
                                        >
                                            <Row>
                                                <Col lg={5} xl={4}>
                                                    <img
                                                        src={bio4}
                                                        alt=""
                                                        className="card-img"
                                                    />
                                                </Col>
                                                <Col lg={7} xl={7}>
                                                    <div className="card-info mt-3 mt-lg-0">
                                                        <h4>{t('products.utrust_surveillance.section_2.box_4.head')}</h4>
                                                        <p>
                                                            {t('products.utrust_surveillance.section_2.box_4.para')}
                                                        </p>
                                                    </div>
                                                </Col>
                                            </Row>
                                        </motion.div>
                                    </Col>
                                </Row>
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

            <div className={'section-2'}>
                <Container>
                    <Row>
                        <Col md={12}>
                            <p className={'mb-5'}>
                                {t('products.utrust_surveillance.section_3.para_1')}
                            </p>
                            <p className={''}>
                                {t('products.utrust_surveillance.section_3.para_2')}
                            </p>
                        </Col>
                    </Row>
                </Container>
            </div>


        </div>
    )
}